import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { EguardConfigService } from '../../../../../core/services/config.service';

@Component({
    selector   : 'eguard-error-404',
    templateUrl: './error-404.component.html',
    styleUrls  : ['./error-404.component.scss']
})
export class EguardError404Component implements OnInit
{
    constructor(
        private eguardConfig: EguardConfigService,
        private location: Location
    )
    {
        this.eguardConfig.setSettings({
            layout: {
                navigation: 'left', // 'right', 'left', 'top', 'none'
                toolbar: 'below', // 'above', 'below', 'none'
                footer: 'none', // 'above', 'below', 'none'
                mode: 'fullwidth' // 'boxed', 'fullwidth'
            }
        });
    }

    ngOnInit()
    {
    }

    goBack() {
        this.location.back();
    }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/components/errors/404/error-404.component.ts